import oroborus from '../../assets/oroborus.jpg';
export default function ArticlePage2(){
    


    return(



        <div className = "fullscreen-parent">
    <img className="fullscreenImage" src= {oroborus} alt="Cover" />
    <h1>
    
        The Gift Vs. the slave <br/>
    <div style={{ fontSize: "20px", fontWeight: 'normal' }}>
        
        September 5th, 2025  <br/>
        3:00 pm <br/>
        <div style={{ fontSize: "10px"}}>Written by August</div>
        
    </div>
         </h1> 

         <p className = "postContent">
            
Every person has two minds: the intuitive and the rational mind. <br/><br/>

The intuitive mind is instinctual: it is how we react to the subconscious connections that our brains make with the world around us.<br/><br/>

The rational mind is the opposite: it is the carefully calculated decisions that we make.<br/><br/>

Humans require data in order to create rationale, this data comes in the form of past experiences, relationships, education and sometimes even actual numbers. <br/><br/>

The limitation of rationale is how dependent it is on the quality of said data. If the data is biased, then it makes it difficult for people to come to conclusions that are outside of that bias, or not immediately present within the data. <br/><br/>

The root of this problem is the way in which data is communicated: always from one person to another.<br/><br/>

Think of it as a big game of broken telephone. When someone receives a piece of information, their personal opinions pollute it. After the information has been skewed to their liking, it is then passed down to you.<br/><br/>

Therefore a lot of the information that we receive is not information, but an opinion.<br/><br/>

Hence the importance of asking questions of the things that we take for granted:<br/><br/>

How often do you think about what you are doing? Do you ask yourself if the decision you are about to make “makes sense”? How do you come to a conclusion on what you “should” do? <br/><br/>

What does “should” actually mean? What do right and wrong even mean?<br/><br/>

The intuitive mind is different. Intuition is more authentic, but is not to be mistaken for emotion. Intuition is actually very logical, the difference is just that the logic is not tainted by what other people tell you, and is instead your natural perception. <br/>

It is less about thinking, and more about acting on innate feelings. The moment that we think about our perceptions, we allow them to be tainted by our logic bias.<br/><br/>

The difficulty of intuition is also in the communication of it. It is not easily described, but everyone has felt it. My most accurate description of it is when we have experienced the power of logic, and now long for the grace of intuition. <br/><br/>

So I guess that what I’m trying to say, is don’t ignore your gut in the face of “facts”. <br/><br/>

"The intuitive mind is a sacred gift and the rational mind is a faithful servant. We have created a society that honors the servant and has forgotten the gift” - Einstein<br/><br/>


Also, try this idea from Kanye West: <br/><br/>

“a two-year-old jumps on a coffee table and someone says, That’s a coffee table, don’t jump on that! So it went from being something that makes him feel like Superman, he’s got his cape on, to something where he has to think about — this person <br/> is 
like a family member he doesn’t like anyway — he’s two years old, he doesn’t give a shit about a coffee or a table. And he’s starting to like calculate all these things. And by the time you are 40 years old, you’ve got a wall full of coffee tables <br/>
calculating you into traffic, calculating you into your career choice, calculating you into this house, townhouse that’s not quite as big as the townhouse next [to it], and it just never works. That’s the simulation that I’m talking about. That’s what I mean when I say simulation."<br/>
</p>
    
    </div>


    )



}